export { default, RECORDS_PER_PAGE } from "./SpaceChart";
